import React from 'react';
import ApplicationForm from '../components/ApplicationForm';

export default function ApplyPage({ selectedService }) {
  return (
    <section className="page-section">
      <ApplicationForm selectedService={selectedService} />
    </section>
  );
}
